import React from 'react';
import { connect } from 'react-redux';

import * as StoryActions from "../../data/stories/StoryActions";

import PublishStoryModal from './PublishStoryModal';

const mapStateToProps = (state, ownProps) => ({
    slug: state.accounts[state.currentAccountId].slug
});

const mapDispatchToProps = {
    onPublish: StoryActions.publishStory,
    onUnpublish: StoryActions.unpublishStory
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PublishStoryModal);
